import { iDocPlayerDataMap } from './docPlayer.types';

import { docPlayerEffects, docPlayerReducers } from './docPlayer.operator';

// DocPlayer 初始状态
export const docPlayerInitDataMap: iDocPlayerDataMap = {};

// Model
export const docPlayerModel = {
  state: docPlayerInitDataMap,
  reducers: docPlayerReducers,
  effects: docPlayerEffects,
};
